export default __webpack_public_path__ + "static/media/thumbnail.21771e66.webp";